import { each, isEmpty, replace, forEach, indexOf, find } from 'lodash';
import ReactHtmlParser from 'react-html-parser';
import { sanitize } from 'dompurify';
export var FILE_TYPE_PATTERN = /(\.csv|\.xlsx)$/i;
export var getLabelWithParam = function getLabelWithParam() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var labels = message;
  if (!isEmpty(labels) && !isEmpty(param)) {
    each(param, function (value, key) {
      labels = replace(labels, "{".concat(key, "}"), value);
    });
  }
  return labels;
};
export var getFooterLanguageLink = function getFooterLanguageLink(link) {
  var isEProcurementApp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var defaultPathFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var defaultPath = defaultPathFormat.split('/');
  var linkPathname = link && link.split('/') || [];
  var pathVars = {};
  forEach(linkPathname, function (value, key) {
    if (!isEmpty(value)) {
      pathVars[defaultPath[key]] = value;
    }
  });
  var pathname = window.location.pathname;
  var pathList = pathname.split('/');
  var path = pathList.pop();
  var localeCountry = pathVars.localeCountry,
    localeLanguage = pathVars.localeLanguage;
  if (isEmpty(localeCountry) && isEmpty(localeLanguage)) {
    return '/';
  }
  var linkURL = "/store/".concat(localeCountry, "/").concat(localeLanguage, "/").concat(path);
  if (isEProcurementApp) {
    linkURL = "/store/".concat(localeLanguage, "/").concat(path);
  }
  return linkURL;
};
var bytesToKb = function bytesToKb(size) {
  return parseInt(Math.floor(size / 1000));
};
var configFileSize = function configFileSize(config) {
  var poAttachmentFileSize = config.poAttachmentFileSize;
  if (!isEmpty(poAttachmentFileSize)) {
    var fileType = poAttachmentFileSize.slice(-2);
    switch (fileType) {
      case 'MB':
        return parseInt(poAttachmentFileSize.split('MB')[0]) * 1024;
      case 'KB':
        return parseInt(poAttachmentFileSize.split('KB')[0]);
      default:
        return parseInt(poAttachmentFileSize);
    }
  }
};
export var validateUploadFile = function validateUploadFile(fileObj, labels, config) {
  var status = false;
  var error = '';
  var specialChar = new RegExp(config.poFileNameRegx);
  var name = fileObj.name,
    size = fileObj.size;
  var fileSize = bytesToKb(size);
  var sizeFromConfig = configFileSize(config);
  if (fileSize > sizeFromConfig) {
    status = true;
    error = labels.poAttachmentFileSizeErrorMsg;
  } else if (specialChar.test(name)) {
    status = true;
    error = labels.poAttachmentFileNameErrorMsg;
  } else if (name.length > parseInt(config.maxFileSize)) {
    status = true;
    error = labels.poAttachmentFileNameLengthErrorMsg;
  }
  return {
    status: status,
    error: error
  };
};
export var getTernaryCondition = function getTernaryCondition(condition, exprIfTrue, exprIfFalse) {
  return condition ? exprIfTrue : exprIfFalse;
};
export var getOrCondition = function getOrCondition(value1, value2) {
  return value1 || value2;
};
export var htmlParser = function htmlParser() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  try {
    return ReactHtmlParser(text.trim()).toString();
  } catch (err) {
    return text;
  }
};
export var disableCountryLanguage = function disableCountryLanguage(disableFooterSelector) {
  var status = false;
  var pathname = window.location.pathname;
  var pathList = pathname && pathname.split('/') || [];
  var pageName = pathList.pop();
  var isDisableFooter = find(disableFooterSelector, function (item) {
    return item === pageName;
  });
  if (isDisableFooter) {
    status = true;
  }
  return status;
};
export var getLabelWithComponent = function getLabelWithComponent() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var labels = message.split(/\{(.?)\}/gi);
  each(param, function (value, key) {
    var findIndex = indexOf(labels, "".concat(key));
    if (findIndex !== -1) {
      labels[findIndex] = value;
    }
  });
  return labels;
};
export var urlSanitize = function urlSanitize(dirtyUrl) {
  return sanitize(dirtyUrl, {
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  });
};
export var isScrollBarVisible = function isScrollBarVisible(elementId) {
  var isVisible = false;
  var element = document.getElementById(elementId);
  if (element && element.scrollWidth > element.clientWidth + 1) {
    isVisible = true;
  }
  return isVisible;
};